/* TU Labs, global (loaded defer from layout/theme.liquid on every page; ERP docs/35).
   The assignment block in theme.liquid has already set window.tuAb (key -> arm),
   window.tuAbRunning (keys with status running), window.tuAbPages (key -> page),
   window.tuAbPageType (this page) and the cookie tu_ab ("key:arm|key:arm:page").
   1. Cart attribute stamp: every RUNNING experiment's arm goes onto the cart as
      tu_ab_<key> (plus tu_device = mobile | desktop since 31 Oct 2026, so the ERP can
      read orders by device), so it lands on the order and the ERP counts orders per arm. Moved
      here from assets/tu-reassure.js (PDP only) on 21 Sep 2026 so a cart-page
      experiment is stamped wherever the drawer opens; tu-reassure.js skips its own
      stamp when this file is present (window.__tuLabsStamp).
   2. GA4 events for every RUNNING experiment (tu_ab_x_<key> exposure, tu_ab_atc_<key>,
      tu_ab_co_<key>, parameter ab_variant), sent through the store's own Google tag so
      they sit in the visitor's real GA4 session. Replaced the customer-events pixel on
      5 Oct 2026 (its sandboxed GA client created sessions with no page_view).
   3. Experiment cd1 (html.tu-x-cd1-b): keep the pay-in-4 amount in step with the
      subtotal and the strip's dispatch / free-shipping wording in step with the cart.
   Rebased on the live theme 28 Sep 2026: the dispatch line honours the ERP warehouse
   closures like the PDP bar; tu-reassure.js on live already carries the stamp guard. */
(function () {
  'use strict';
  window.__tuLabsStamp = true;

  var arms = window.tuAb || {};
  var running = window.tuAbRunning || [];
  var pages = window.tuAbPages || {};

  /* ---------- 1. Cart attribute stamp ---------- */
  var stamped = false;
  /* The device beside the arms (31 Oct 2026, ERP mig 219): the ERP reads a phones-only
     experiment on phone orders, and every readout splits phones from desktop. The theme's
     own breakpoint decides (749px, the width the mobile layout applies at), not the user
     agent: a tablet renders the desktop layout and counts as desktop. */
  function deviceBucket() {
    try { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'; }
    catch (e) { return 'desktop'; }
  }
  function stampFields() {
    var out = {};
    for (var i = 0; i < running.length; i++) { if (arms[running[i]]) out['tu_ab_' + running[i]] = arms[running[i]]; }
    if (Object.keys(out).length) out.tu_device = deviceBucket();
    return out;
  }
  function stampCart() {
    if (stamped) return;
    var fields = stampFields(), sig = JSON.stringify(fields);
    if (sig === '{}') { stamped = true; return; } /* nothing running */
    try { if (sessionStorage.getItem('tu_ab_stamped') === sig) { stamped = true; return; } } catch (e) {}
    if (!/(?:^|;\s*)cart=/.test(document.cookie)) return; /* no cart yet */
    stamped = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: fields })
    })
      .then(function () { try { sessionStorage.setItem('tu_ab_stamped', sig); } catch (e) {} })
      .catch(function () { stamped = false; });
  }
  function armStamp() {
    stampCart();
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && /\/cart\/add/.test(form.getAttribute('action') || '')) {
        setTimeout(stampCart, 1500);
        setTimeout(stampCart, 4000);
      }
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('button[name="add"], .kaching-bundles__block button')) {
        setTimeout(stampCart, 2000);
        setTimeout(stampCart, 5000);
      }
    }, true);
  }

  /* ---------- 2. GA4 events, through the store's own Google tag ----------
     For every RUNNING experiment (cookie tu_ab, read as the pixel read it):
       tu_ab_x_<key>    exposure, on the page the experiment lives on: the product view for
                        pdp, the collection / home page view, the cart drawer opening for
                        cart; any other page calls window.tuLabsExpose(key) from its own code
       tu_ab_atc_<key>  a successful /cart/add on any path (product form, sticky bar, add-ons,
                        bundles, drawer upsells): what Shopify's product_added_to_cart counted
       tu_ab_co_<key>   checkout intent: the click on a checkout button (drawer or cart page),
                        because no theme code runs on the checkout pages
     each with ab_variant (the registered GA4 dimension) and ab_test, once per page view (the
     ERP counts sessions, services/labs.py). They go out on window.gtag, the tag the Google &
     YouTube channel loads at top level, addressed to the GA4 stream only, so they carry the
     page_view's client and session. The arm always comes from the cookie, never from a
     caller. Nothing is sent, wrapped or listened for while nothing is running.
     QA: on an unpublished (preview) theme a forced arm (?tu_ab_<key>=a|b) reports as well,
     so the events can be checked in GA4 realtime before a Start. Never on the live theme. */
  var GA_ID = 'G-5R278MTMV3';
  var PAGE_TYPE = { pdp: 'product', collection: 'collection', home: 'index' };
  /* QA only: the page of a queued experiment that has no metaobject yet. */
  var QA_PAGES = { cd1: 'cart', fbt2: 'other', btn1: 'site', xc1: 'cart' };
  var qa = false, design = false;
  try {
    design = !!(window.Shopify && Shopify.designMode);
    qa = !design && !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  } catch (e) {}

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function assignments() {
    var out = [], seen = {};
    if (design) return out; /* theme editor: nothing is assigned there, a stale cookie must not report */
    try {
      readCookie('tu_ab').split('|').forEach(function (part) {
        var m = /^([a-z0-9]{2,12}):(a|b)(?::([a-z]{2,12}))?$/.exec(part.trim());
        if (m && !seen[m[1]]) { seen[m[1]] = 1; out.push({ key: m[1], arm: m[2], page: m[3] || 'pdp' }); }
      });
      if (qa) {
        readCookie('tu_ab_force').split('|').forEach(function (part) {
          var m = /^([a-z0-9]{2,12}):(a|b)$/.exec(part.trim());
          /* the arm actually applied (an adopted arm overrides a forced one) */
          if (m && !seen[m[1]]) { seen[m[1]] = 1; out.push({ key: m[1], arm: arms[m[1]] || m[2], page: pages[m[1]] || QA_PAGES[m[1]] || 'pdp' }); }
        });
      }
    } catch (e) {}
    return out;
  }

  /* The tag is ready once the channel has queued (or loaded) the GA4 stream's config: an
     event pushed after that is processed after it, by the same client as the page_view. */
  function gaReady() {
    if (typeof window.gtag !== 'function') return false;
    try {
      var dl = window.dataLayer || [];
      for (var i = 0; i < dl.length; i++) { if (dl[i] && dl[i][0] === 'config' && dl[i][1] === GA_ID) return true; }
      if (window.google_tag_manager && window.google_tag_manager[GA_ID]) return true;
    } catch (e) {}
    return false;
  }
  var queue = [], poll = null, waited = 0, gaveUp = false;
  function flush() {
    if (!queue.length) return true;
    if (!gaReady()) return false;
    while (queue.length) {
      var q = queue.shift();
      try { window.gtag('event', q.name, q.params); } catch (e) {}
    }
    return true;
  }
  /* The tag loads after this file on a cold page: hold the events for up to 30 s, then
     drop them (tag blocked). Better no event than one outside the session. */
  function send(name, x) {
    queue.push({ name: name, params: { send_to: GA_ID, ab_variant: x.arm, ab_test: x.key } });
    if (flush()) return;
    if (gaveUp) { queue.length = 0; return; }
    if (poll) return;
    poll = setInterval(function () {
      waited += 500;
      if (flush()) { clearInterval(poll); poll = null; }
      else if (waited >= 30000) { clearInterval(poll); poll = null; gaveUp = true; queue.length = 0; }
    }, 500);
  }
  var sent = {};
  function report(prefix, test) {
    assignments().forEach(function (x) {
      if (test && !test(x)) return;
      var name = prefix + x.key;
      if (sent[name]) return;
      sent[name] = 1;
      send(name, x);
    });
  }

  function exposePage() {
    var type = window.tuAbPageType || '';
    if (type) report('tu_ab_x_', function (x) { return PAGE_TYPE[x.page] === type; });
  }
  function exposeDrawer() { report('tu_ab_x_', function (x) { return x.page === 'cart'; }); }
  window.tuLabsExpose = function (key) {
    report('tu_ab_x_', function (x) { return x.key === key && !PAGE_TYPE[x.page]; });
  };

  /* Add to cart: watch the /cart/add responses, the same way Shopify's own storefront
     instrumentation raises product_added_to_cart (it wraps fetch and XMLHttpRequest too).
     The original promise / request is handed back untouched. */
  var checkoutSeen = false;
  function isAdd(url) { return /\/cart\/add(?:\.js|\.json)?(?:[?#]|$)/.test(String(url || '')); }
  /* After the checkout click the only add is the engine's own shipping-protection line. */
  function added() { if (!checkoutSeen) report('tu_ab_atc_'); }
  function watchAdds() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input) {
        var p = nativeFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || String(input);
          if (isAdd(url)) p.then(function (r) { if (r && r.ok) added(); }, function () {});
        } catch (e) {}
        return p;
      };
    }
    var X = window.XMLHttpRequest && XMLHttpRequest.prototype;
    if (X && X.open && X.send) {
      var xOpen = X.open, xSend = X.send;
      X.open = function (method, url) {
        try { this.__tuLabsAdd = isAdd(url); } catch (e) {}
        return xOpen.apply(this, arguments);
      };
      X.send = function () {
        try {
          if (this.__tuLabsAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) added(); });
        } catch (e) {}
        return xSend.apply(this, arguments);
      };
    }
    /* A form that posts to /cart/add natively (no script took the submit over). */
    window.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (f && f.getAttribute && isAdd(f.getAttribute('action')) && !e.defaultPrevented) added();
      } catch (err) {}
    });
  }
  /* Checkout intent: capture phase, so it is queued before the drawer engine navigates;
     the tag sends what it holds as a beacon when the page hides. */
  var CHECKOUT_SEL = '.tu-cart__checkout, [name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  function watchCheckout() {
    document.addEventListener('click', function (e) {
      try {
        if (e.target && e.target.closest && e.target.closest(CHECKOUT_SEL)) { checkoutSeen = true; report('tu_ab_co_'); }
      } catch (err) {}
    }, true);
    window.addEventListener('pageshow', function (e) { if (e.persisted) checkoutSeen = false; });
  }
  if (assignments().length) { watchAdds(); watchCheckout(); }

  /* ---------- 3. cd1: amounts and wording follow the cart ---------- */
  function money(cents) {
    var cfg = window.TUCartConfig || {};
    var sym = cfg.currencySymbol || '$';
    var p = (cents / 100).toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sym + p.join('.');
  }
  function parseMoney(text) {
    var n = parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function melbourneNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', weekday: 'short', hour: 'numeric', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var out = {};
      parts.forEach(function (p) { out[p.type] = p.value; });
      return { day: out.weekday, hour: parseInt(out.hour, 10), iso: out.year + '-' + out.month + '-' + out.day };
    } catch (e) { return null; }
  }
  /* Warehouse closures (ERP calendar, shop metafield custom.warehouse_closures, rendered as
     JSON in the drawer and on the PDP): the same logic as assets/tu-reassure.js dispatchText,
     which the ERP pins in warehouse_closures.shopper_sees; change all three together. */
  var closures = null;
  function readClosures() {
    if (closures) return closures;
    closures = { closed: {}, periods: [] };
    var el = document.querySelector('script[data-tu-closures]');
    if (!el) return closures;
    try {
      var data = JSON.parse(el.textContent);
      (data.closed || []).forEach(function (d) { closures.closed[d] = true; });
      closures.periods = data.periods || [];
    } catch (e) {}
    return closures;
  }
  function isoAdd(iso, days) {
    var d = new Date(iso + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
  }
  function isOpenDay(iso) {
    var wd = new Date(iso + 'T00:00:00Z').getUTCDay();
    return wd !== 0 && wd !== 6 && !readClosures().closed[iso];
  }
  function dispatchText(now) {
    if (!now || !/^\d{4}-\d{2}-\d{2}$/.test(now.iso)) return 'Ships next business day';
    if (isOpenDay(now.iso) && now.hour < 12) return 'Order by midday: ships today';
    var next = isoAdd(now.iso, 1), guard = 0;
    while (!isOpenDay(next) && guard++ < 60) next = isoAdd(next, 1);
    var periods = readClosures().periods;
    for (var i = 0; i < periods.length; i++) {
      var p = periods[i];
      if (p.from < next && p.to >= now.iso && p.pdp) return p.pdp;
    }
    return 'Ships next business day';
  }
  var latestCart = null;
  function cartItems() {
    var c = latestCart || window.__tuCartData;
    return (c && c.items) || [];
  }
  /* The page-load snapshot (__tuCartData) predates any add on this page, so re-read the
     cart on open before judging vendor / pre-order state. */
  function refreshCart(then) {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { latestCart = c; then(); })
        .catch(function () {});
    } catch (e) {}
  }
  function updateCd1(root) {
    var pay = root.querySelector('[data-tu-cd-payline]');
    var strip = root.querySelector('[data-tu-cd-assure]');
    if (!pay && !strip) return;
    var subEl = root.querySelector('.tu-cart__subtotal-val');
    var sub = subEl ? parseMoney(subEl.textContent) : 0;
    var empty = sub <= 0 || !!root.querySelector('.tu-cart__items .tu-cart__empty');
    /* Pay in 4: hidden on an empty cart and above Afterpay's $2,000 order limit. */
    if (pay) {
      pay.hidden = empty || sub > 200000;
      var amt = pay.querySelector('[data-tu-cd-payline-amt]');
      if (amt) amt.textContent = money(Math.round(sub / 4));
    }
    if (strip) {
      strip.hidden = empty;
      /* Dispatch: the PDP promise (assets/tu-reassure.js), AVIONLUX ships from its own
         warehouse and pre-orders wait for stock, so neither gets the midday cutoff. */
      var items = cartItems();
      var preVids = window.__tuPreorderVids || [];
      var overseas = items.some(function (i) { return /avionlux/i.test(i.vendor || ''); });
      /* The drawer engine labels a pre-order line itself, including one added on this page
         (the page-load list __tuPreorderVids cannot know those): its label comes first. */
      var preorder = !!root.querySelector('.tu-cart__items .tu-cart__item-preorder') ||
        items.some(function (i) { return preVids.indexOf(i.variant_id) >= 0; });
      var text = strip.querySelector('[data-tu-cd-dispatch-text]');
      if (text) {
        if (preorder) text.textContent = 'Pre-order items ship when stock lands';
        else if (overseas) text.textContent = 'Ships next business day';
        else text.textContent = dispatchText(melbourneNow());
      }
      /* Free shipping: the threshold from the drawer's own config; AU only (Liquid hides the column elsewhere). */
      var fs = strip.querySelector('[data-tu-cd-freeship]');
      var cfg = (window.TUCartConfig && window.TUCartConfig.cartDrawer) || {};
      var threshold = Number(cfg.free_ship && cfg.free_ship.threshold) || 99;
      if (fs) {
        var title = fs.querySelector('[data-tu-cd-freeship-title]');
        var sub2 = fs.querySelector('[data-tu-cd-freeship-text]');
        var unlocked = sub >= threshold * 100;
        fs.classList.toggle('tu-cart__assure-col--unlocked', unlocked);
        if (title) title.textContent = unlocked ? 'Free shipping' : 'Free shipping*';
        if (sub2) sub2.textContent = unlocked ? 'Unlocked on this order' : 'Orders over $' + threshold;
      }
    }
  }

  function init() {
    armStamp();
    exposePage();
    var root = document.getElementById('tu-cart');
    if (!root) return;
    var cd1 = document.documentElement.classList.contains('tu-x-cd1-b');
    if (cd1) updateCd1(root);
    /* Drawer open: exposure for cart-page experiments, a fresh stamp (the cart exists by now)
       and the cd1 refresh. Subtotal changes (engine re-render) refresh cd1 too. */
    new MutationObserver(function () {
      if (root.classList.contains('tu-cart--open')) {
        exposeDrawer(); stampCart();
        if (cd1) { updateCd1(root); refreshCart(function () { updateCd1(root); }); }
      }
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
    if (cd1) {
      var subEl = root.querySelector('.tu-cart__subtotal-val');
      if (subEl) new MutationObserver(function () { updateCd1(root); }).observe(subEl, { childList: true, characterData: true, subtree: true });
      var items = root.querySelector('.tu-cart__items');
      if (items) new MutationObserver(function () { updateCd1(root); }).observe(items, { childList: true, subtree: true });
    }
    if (root.classList.contains('tu-cart--open')) { exposeDrawer(); if (cd1) updateCd1(root); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
